/// Auto-generated with ScanbotSDKCodegenV3. Modifications will be overwritten.
/// Generated from rtu-ui-v2/schemas/vin/VINScannerScreenTextLocalization.yaml
import { PartiallyConstructible } from '../../utils/utils';
/**
Configuration of the all strings for generic text scanner screen.
*/
export class VinScannerScreenTextLocalization extends PartiallyConstructible {
    /** @param source {@displayType `DeepPartial<VinScannerScreenTextLocalization>`} */
    constructor(source = {}) {
        super();
        /**
          Title for the top bar.
          
          Default is "VIN Scanner"
          */
        this.topBarTitle = 'VIN Scanner';
        /**
          Cancel button text for the top bar.
          
          Default is "Cancel"
          */
        this.topBarCancelButton = 'Cancel';
        /**
          Text for the top user guidance caption.
          
          Default is "Point the camera at the VIN"
          */
        this.topUserGuidance = 'Point the camera at the VIN';
        /**
          Text for the user guidance caption below the finder view.
          
          Default is "Looking for VIN..."
          */
        this.finderViewUserGuidance = 'Looking for VIN...';
        /**
          Title for the introduction screen.
          
          Default is "How to scan a VIN"
          */
        this.introScreenTitle = 'How to scan a VIN';
        /**
          Start scanning button text for the introduction screen.
          
          Default is "Start Scanning"
          */
        this.introScreenDoneButton = 'Start Scanning';
        /**
          The text explanation for the introduction screen.
          
          Default is "A VIN (Vehicle Identification Number) is a unique code you'll find on a vehicle's windshield or on the inside of the driver's door. \n\nTo scan, simply point your camera at the VIN, ensuring it's within the frame. The VIN will be automatically extracted.\n\nTap 'Start Scanning' to begin."
          */
        this.introScreenText = "A VIN (Vehicle Identification Number) is a unique code you'll find on a vehicle's windshield or on the inside of the driver's door. \n\nTo scan, simply point your camera at the VIN, ensuring it's within the frame. The VIN will be automatically extracted.\n\nTap 'Start Scanning' to begin.";
        /**
          Caption for the success overlay.
          
          Default is "Scanned successfully"
          */
        this.completionOverlaySuccessMessage = 'Scanned successfully';
        /**
          Accessibility description for the 'open introduction screen' button in top bar.
          
          Default is "Open VIN Scanner introduction"
          */
        this.accessibilityDescriptionOpenIntroScreenButton = 'Open VIN Scanner introduction';
        /**
          Accessibility description for the 'done'/'start scanning' button in the introduction screen.
          
          Default is "Start VIN scanning"
          */
        this.accessibilityDescriptionIntroScreenDoneButton = 'Start VIN scanning';
        /**
          Accessibility description for the 'cancel' button in the top bar.
          
          Default is "Cancel VIN scanning"
          */
        this.accessibilityDescriptionCancelButton = 'Cancel VIN scanning';
        /**
          Title for the text pattern confirmation alert.
          
          Default is "VIN detected"
          */
        this.vinConfirmationAlertTitle = 'VIN detected';
        /**
          Cancel button text for the text pattern confirmation alert.
          
          Default is "Cancel"
          */
        this.vinConfirmationAlertCancelButton = 'Cancel';
        /**
          Submit button text for the text pattern confirmation alert.
          
          Default is "Submit"
          */
        this.vinConfirmationAlertSubmitButton = 'Submit';
        /**
          Accessibility description for the cancel button in the text pattern confirmation alert.
          
          Default is "Cancel VIN scanning"
          */
        this.accessibilityDescriptionConfirmationCancelButton = 'Cancel VIN scanning';
        /**
          Accessibility description for the submit button in the text pattern confirmation alert.
          
          Default is "Submit VIN scan result"
          */
        this.accessibilityDescriptionConfirmationSubmitButton = 'Submit VIN scan result';
        /**
          Accessibility description for the flash button.
          
          Default is "Toggle flash"
          */
        this.accessibilityDescriptionFlashButton = 'Toggle flash';
        /**
          Accessibility description for the zoom button.
          
          Default is "Toggle camera zoom"
          */
        this.accessibilityDescriptionZoomButton = 'Toggle camera zoom';
        /**
          Accessibility description for the flip camera button.
          
          Default is "Flip camera"
          */
        this.accessibilityDescriptionFlipCameraButton = 'Flip camera';
        /**
          The title of the camera permission dialog.
          
          Default is "Camera permission denied!"
          */
        this.cameraPermissionEnableCameraTitle = 'Camera permission denied!';
        /**
          The explanation text of the camera permission dialog.
          
          Default is "Please allow the usage of the camera to start the scanning process."
          */
        this.cameraPermissionEnableCameraExplanation = 'Please allow the usage of the camera to start the scanning process.';
        /**
          The 'enable' button title of the camera permission dialog.
          
          Default is "Grant permission"
          */
        this.cameraPermissionEnableCameraButton = 'Grant permission';
        /**
          The 'close' button title of the camera permission dialog.
          
          Default is "Close"
          */
        this.cameraPermissionCloseButton = 'Close';
        /**
          The accessibility hint for the 'enable' button of the camera permission dialog.
          
          Default is "Tap to grant camera permission"
          */
        this.accessibilityDescriptionCameraPermissionEnableCameraButton = 'Tap to grant camera permission';
        /**
          The accessibility hint for the 'close' button of the camera permission dialog.
          
          Default is "Close screen without granting permission"
          */
        this.accessibilityDescriptionCameraPermissionCloseButton = 'Close screen without granting permission';
        if (source.topBarTitle !== undefined) {
            this.topBarTitle = source.topBarTitle;
        }
        if (source.topBarCancelButton !== undefined) {
            this.topBarCancelButton = source.topBarCancelButton;
        }
        if (source.topUserGuidance !== undefined) {
            this.topUserGuidance = source.topUserGuidance;
        }
        if (source.finderViewUserGuidance !== undefined) {
            this.finderViewUserGuidance = source.finderViewUserGuidance;
        }
        if (source.introScreenTitle !== undefined) {
            this.introScreenTitle = source.introScreenTitle;
        }
        if (source.introScreenDoneButton !== undefined) {
            this.introScreenDoneButton = source.introScreenDoneButton;
        }
        if (source.introScreenText !== undefined) {
            this.introScreenText = source.introScreenText;
        }
        if (source.completionOverlaySuccessMessage !== undefined) {
            this.completionOverlaySuccessMessage = source.completionOverlaySuccessMessage;
        }
        if (source.accessibilityDescriptionOpenIntroScreenButton !== undefined) {
            this.accessibilityDescriptionOpenIntroScreenButton = source.accessibilityDescriptionOpenIntroScreenButton;
        }
        if (source.accessibilityDescriptionIntroScreenDoneButton !== undefined) {
            this.accessibilityDescriptionIntroScreenDoneButton = source.accessibilityDescriptionIntroScreenDoneButton;
        }
        if (source.accessibilityDescriptionCancelButton !== undefined) {
            this.accessibilityDescriptionCancelButton = source.accessibilityDescriptionCancelButton;
        }
        if (source.vinConfirmationAlertTitle !== undefined) {
            this.vinConfirmationAlertTitle = source.vinConfirmationAlertTitle;
        }
        if (source.vinConfirmationAlertCancelButton !== undefined) {
            this.vinConfirmationAlertCancelButton = source.vinConfirmationAlertCancelButton;
        }
        if (source.vinConfirmationAlertSubmitButton !== undefined) {
            this.vinConfirmationAlertSubmitButton = source.vinConfirmationAlertSubmitButton;
        }
        if (source.accessibilityDescriptionConfirmationCancelButton !== undefined) {
            this.accessibilityDescriptionConfirmationCancelButton = source.accessibilityDescriptionConfirmationCancelButton;
        }
        if (source.accessibilityDescriptionConfirmationSubmitButton !== undefined) {
            this.accessibilityDescriptionConfirmationSubmitButton = source.accessibilityDescriptionConfirmationSubmitButton;
        }
        if (source.accessibilityDescriptionFlashButton !== undefined) {
            this.accessibilityDescriptionFlashButton = source.accessibilityDescriptionFlashButton;
        }
        if (source.accessibilityDescriptionZoomButton !== undefined) {
            this.accessibilityDescriptionZoomButton = source.accessibilityDescriptionZoomButton;
        }
        if (source.accessibilityDescriptionFlipCameraButton !== undefined) {
            this.accessibilityDescriptionFlipCameraButton = source.accessibilityDescriptionFlipCameraButton;
        }
        if (source.cameraPermissionEnableCameraTitle !== undefined) {
            this.cameraPermissionEnableCameraTitle = source.cameraPermissionEnableCameraTitle;
        }
        if (source.cameraPermissionEnableCameraExplanation !== undefined) {
            this.cameraPermissionEnableCameraExplanation = source.cameraPermissionEnableCameraExplanation;
        }
        if (source.cameraPermissionEnableCameraButton !== undefined) {
            this.cameraPermissionEnableCameraButton = source.cameraPermissionEnableCameraButton;
        }
        if (source.cameraPermissionCloseButton !== undefined) {
            this.cameraPermissionCloseButton = source.cameraPermissionCloseButton;
        }
        if (source.accessibilityDescriptionCameraPermissionEnableCameraButton !== undefined) {
            this.accessibilityDescriptionCameraPermissionEnableCameraButton =
                source.accessibilityDescriptionCameraPermissionEnableCameraButton;
        }
        if (source.accessibilityDescriptionCameraPermissionCloseButton !== undefined) {
            this.accessibilityDescriptionCameraPermissionCloseButton =
                source.accessibilityDescriptionCameraPermissionCloseButton;
        }
    }
}
//# sourceMappingURL=VINScannerScreenTextLocalization.js.map